import Resource from './Resource';

//@TODO get rid of this extension when all the components will use private API prefixes
/**
 * Represents RESTful resource.
 * Does some routine work to communicate with server
 */
class PrivateAPIResource extends Resource {

    /**
     * @returns {string}
     */
    static prefix() {
        let prefix = '';

        const apiVer = 1;

        if (APP_DOMAIN === undefined) {
            throw new Error("You have to specify env variable APP_DOMAIN with a protocol and a hostname.");
        }

        if (BASE_URL) {
            prefix = BASE_URL.endsWith('/') ? BASE_URL.substring(0, BASE_URL.length - 2) : BASE_URL;
        }

        const apiPrefix = `/api/privateV${apiVer}`;

        return APP_DOMAIN + prefix + apiPrefix;
    }

    static clone(resource, originId, isFormData = false) {
        return PrivateAPIResource.create(`${resource}/${originId}/clone`, {}, isFormData);
    }

}

export default PrivateAPIResource;


// WEBPACK FOOTER //
// ./web/src/services/PrivateAPIResource.js